export { default as StrategicAA } from './component';
